<template>
  <Btn
    tag="button"
    :type="type"
    :disabled="loading"
    :size="size"
    :variant="Variant.upgrade"
    data-test-id="upgrade-account"
    icon="arrowRight"
    icon-position="right"
    @click="emit('click')"
  >
    <slot />
  </Btn>
</template>
<script setup lang="ts">
import Btn from '../form/Btn.vue';
import { Variant } from '../../store/types';
import type { FormSize } from '../../lib/services/types';

withDefaults(
  defineProps<{
    loading: boolean;
    type: string;
    size: FormSize;
  }>(),
  { size: 'md' },
);
const emit = defineEmits<{ (e: 'click'): void }>();
</script>
